const contentFeatureTransform = (details) => {
  const featureObj = {};
  details.forEach((detail, index) => {
    featureObj[detail.language] = detail.heading;
  });
  return featureObj;
};

export default contentFeatureTransform;
